import { useSelector } from "react-redux";
import { useIsPro } from "../../imports";
import { useIsElectron } from "../../imports";
import { socketActions } from "../../imports";

export default function ProBadge({ text = "Pro" }) {
	const isPro = useIsPro();
	const isElectron = useIsElectron();
	const cloud = useSelector((state) => state.rundown?.cloud);

	if (isPro) return null;
	return (
		<span
			onClick={() => {
				if (isElectron) return socketActions.openSecondWindow("licence");
				if (cloud) return window.open("https://gfx.live/pricing/", "_blank");
				return window.open("/licence", "_blank");
			}}
			className="my-auto ml-1 h-5 px-1 py-0.5 rounded uppercase font-bold text-xs text-main-100 italic bg-gradient-to-r from-main-500 to-main-700 hover:from-main-400 hover:to-main-600 transition-colors focus:outline-none focus:ring ring-main-500 cursor-pointer"
		>
			{text}
		</span>
	);
}
